// extracted by mini-css-extract-plugin
export default {"banner":"PayPalDeprecationBanner_banner","title":"PayPalDeprecationBanner_title","text":"PayPalDeprecationBanner_text"};